module.exports = __webpack_public_path__ + "static/circle-grocery-d2b2c3130d3dd5a8894232116e894921.png";